module.exports = __webpack_public_path__ + "static/media/sub-weapon.f62d8e0d.png";